import React, { Component } from "react";
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { toast } from "react-toastify";

import { revenuecostService } from "../../../../Services/revenuecostService";

import Revenue from "./Revenue";
import Cost from "./Cost";

class RevenueAndCost extends Component {
  state = {
    totalRevenue: 0,
    totalCost: 0,
  };

  componentDidMount() {
    this.getPnL();
  }

  getPnL = () => {
    let jobId = this.props.jobId;
    revenuecostService.profitAndLoss({ jobId }).then((result) => {
      if (result.status === true) {
        this.setState({
          totalCost: result.data.costTotal,
          totalRevenue: result.data.invoiceTotal,
        });
      }
    });
  };

  render() {
    const { totalRevenue, totalCost } = this.state;
    const {
      jobData,
      jobStatus,
      customerData,
      receiverData,
      quoteToken,
      payInfoData,
      jobId,
      jobToken,
      carrierData,
      formValidator,
      onChangeValue,
      bookingData,
    } = this.props;
    const totalCredit = payInfoData.credit_note_amount
      ? payInfoData.credit_note_amount
      : 0;
    const totalAmt = Number(totalCost) + Number(totalCredit);
    return (
      <>
        <Revenue
        isview={this.props.isview}
          checkInvoice={this.props.checkInvoice}
          jobData={jobData}
          bookingData={bookingData}
          jobStatus={jobStatus}
          customerData={customerData}
          jobId={jobId}
          jobToken={jobToken}
          quoteToken={quoteToken}
          carrierData={carrierData}
          receiverData={receiverData}
          payInfoData={payInfoData}
          formValidator={formValidator}
          onChangeValue={onChangeValue}
          profitNLoss={this.getPnL}
        />
        <Cost
        isview={this.props.isview}
        checkCost={this.props.checkCost}
          jobData={jobData}
          customerData={customerData}
          jobId={jobId}
          jobToken={jobToken}
          formValidator={formValidator}
          onChangeValue={onChangeValue}
          profitNLoss={this.getPnL}
        />

        <Row>
          <Col md={{ span: 4, offset: 8 }}>
            <Table hover variant="dark" size="sm">
              <tbody>
                <tr>
                  <td>Total Revenue</td>
                  <td>{totalRevenue.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Total Credit Note(-AED)</td>
                  <td>{totalCredit.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Total Cost</td>
                  <td>{totalCost.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Total </td>
                  <td>{(totalRevenue - totalAmt).toFixed(2)}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </>
    );
  }
}

export default RevenueAndCost;
